import React, {useState, createContext} from 'react'

const AssignAuditContext = createContext()

function AssignAuditContextProvider(props) {
  const [individual_audit, setIndividualAudit] = useState(false)
  const [audit_users_attributes, setAuditUsersAttributes] = useState([])
  const [audit_email_users_attributes, setAuditEmailUsersAttributes] = useState([])
  const [audit_user_templates_attributes, setAuditUserTemplatesAttributes] = useState([])
  const [selected_templates_users, setSelectedTemplatesUsers] = useState([])
  const [editAssignUser, setEditAssignUser] = useState(true)

  const resetAssignDetails = () => {
    setIndividualAudit(false)
    setAuditUsersAttributes([])
    setAuditEmailUsersAttributes([])
    setAuditUserTemplatesAttributes([])
    setSelectedTemplatesUsers([])
    setEditAssignUser(true)
  }

  const value = {
    individual_audit,
    audit_users_attributes,
    audit_email_users_attributes,
    audit_user_templates_attributes,
    selected_templates_users,
    editAssignUser,

    setIndividualAudit,
    setAuditUsersAttributes,
    setAuditEmailUsersAttributes,
    setAuditUserTemplatesAttributes,
    resetAssignDetails,
    setSelectedTemplatesUsers,
    setEditAssignUser,
  }

  return <AssignAuditContext.Provider value={value}>{props.children}</AssignAuditContext.Provider>
}

const AssignAuditContextConsumer = AssignAuditContext.Consumer

export {AssignAuditContext, AssignAuditContextProvider, AssignAuditContextConsumer}
